const { quickAddCache } = window.BAO.Caches

export class ProductQuickAddLoader extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.getProduct = this.getProduct.bind(this)

    this.listeners.add(this, 'focus', this.getProduct)
    this.listeners.add(this, 'mouseenter', this.getProduct)
  }

  async getProduct () {
    await quickAddCache.get(this.dataset.productHandle)

    this.listeners.remove('focus', this.getProduct)
    this.listeners.remove('mouseenter', this.getProduct)
  }
}

if (!customElements.get('product-quick-add-loader')) {
  customElements.define('product-quick-add-loader', ProductQuickAddLoader)
}

export class ProductQuickAdd extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', event => {
      if (
        event.target.closest('[data-product-quick-add-external-els="trigger"]')
      ) {
        this.handleTriggerClick(event)
      }
    })
  }

  async handleTriggerClick (event) {
    const {
      productHandle: handle,
      productOnlyDefaultVariant,
      productVariantId,
      productId,
    } = event.target.closest(
      '[data-product-quick-add-external-els="trigger"]',
    ).dataset

    if (productOnlyDefaultVariant === 'true') {
      window.BAO.Cart.addItem([
        {
          id: productVariantId,
          product_id: productId,
          quantity: 1,
        },
      ])
    } else {
      this.renderWithProduct(handle)
    }
  }

  /** @param {string} handle */
  async renderWithProduct (handle) {
    this.isBusy = true
    // Clear any post-price addon left by a previously opened drawer so a
    // product without a post group never inherits another product's addon.
    document.body.dataset.postPriceAddon = '0'
    this.innerHTML = await quickAddCache.get(handle)

    this.isBusy = false
  }

  get isBusy () {
    return this.getAttribute('aria-busy') === 'true'
  }

  set isBusy (isBusy) {
    this.setAttribute('aria-busy', String(isBusy))
  }
}

if (!customElements.get('product-quick-add')) {
  customElements.define('product-quick-add', ProductQuickAdd)
}
